export default async function ({ store, redirect, app }) {
    const cartId = app.$storage.getCookie('cart_id');
    await store.dispatch('cart/getCart');
    if (cartId && store.state.cart.cart && store.state.cart.cart.items && store.state.cart.cart.items.length > 0) {
    } else {
        return redirect('/');
    }
}
